// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-form-input-listasuspensa .drag-listasuspensa-wrapper .campo.has-error .mce-content-body {\n  border-bottom-color: #a94442 !important;\n}", ""]);
// Exports
module.exports = exports;
